// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__cOQNQ","p2":"Footer_p2__RUrUB"};